<template>
  <nav class="flex-shrink-0 bg-white dark:bg-gray-800 shadow-md py-4 px-6 flex justify-between items-center z-50">
    <router-link to="/" class="flex items-center space-x-2 cursor-pointer">
      <img src="@/assets/logo.png" alt="智云天宫" class="w-8 h-8 rounded-lg object-contain" />
      <span class="text-xl font-bold text-gray-800 dark:text-white">智云天宫</span>
    </router-link>

    <!-- 桌面端导航链接 -->
    <div class="hidden md:flex space-x-8">
    </div>

    <!-- 暗色模式切换 -->
    <div class="flex items-center">
      <button
        @click="toggleDarkMode"
        class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        aria-label="切换暗色模式"
      >
        <svg
          v-if="!darkMode"
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-gray-700 dark:text-gray-300"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-yellow-400"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavHeader',
  inject: ['darkMode', 'toggleDarkMode']
}
</script>
